<template>
	<div class="header">
		<div v-if="currentRouteName != 'admin'" v-html="css"></div>
		<div
			style="color: var(--theme-text-color); vertical-align: middle; position: absolute;"
			class="flex space-x-5">
			<router-link :to="{ name: 'main' }"><b>SmartMyData</b></router-link>
			<div v-for="(elem, idx) in menu" :key="'menu' + idx">
				<router-link :to="'/products/' + elem.page">{{elem["name_" + $root.$i18n.locale]}}</router-link>
			</div>
		</div>
		<div
			style="color: var(--theme-text-color); vertical-align: middle;"
			class="flex space-x-5 justify-end">
			<div v-if="false && !back">
				<b-alert 
					title="Déconnexion du serveur" 
					style="margin-top: 10px; margin-bottom: -50px" 
					variant="danger" show><b>Serveur déconnecté</b>
				</b-alert>	
			</div>
			<b-button style="margin: 0px;padding: 0px;" variant="link" @click="change_lang"><country-flag :country="$root.$i18n.locale == 'fr' ? 'fr' : 'us'" size='small' style="padding: 0px;"/></b-button>
			<router-link v-show="isAdmin" :to="{ name: 'admin' }"><i class="fa fa-cogs"></i></router-link>
			<router-link v-if="user_vuex.identifiant" :to="{ name: 'profile' }"><i class="fa fa-user"></i></router-link>
			<router-link v-else :to="{ name: 'login' }"><i class="fa fa-user"></i></router-link>
			<router-link v-show="user_vuex.identifiant" :to="{ name: 'logout' }"><i class="fa fa-sign-out-alt"></i></router-link>
		</div>
	</div>
</template>

<script>
	import store from "../store";
	import users from "../services/users.js";
    import products from "../services/products.js";

	import CountryFlag from 'vue-country-flag'

	export default {
		name: "saas-navbar",
		components: {
			CountryFlag
		},
		data() {
			return {
				user: {},
				css: "",
				menu: []
			};
		},
        computed: {
			currentRouteName() {
				return this.$route.name;
			},
            isAdmin: function() {
                return store.getters.isUserAdmin;
            },
            user_vuex: function() {
                return store.getters.getUser;
            },
			back() {
				return this.$store.getters.getBack
			}
        },
		methods: {
			change_lang()
			{
				this.$root.$i18n.locale = (this.$root.$i18n.locale == 'fr') ? 'en' : 'fr'; 
				store.commit('setLang', this.$root.$i18n.locale);
			},
			async set()
			{
				console.log("set style and menu")
				try {
					this.css = await products.load_css();
				}
				catch (err) {
					console.log(err)
				};

				try {
					this.menu = await products.load_menu();
				}
				catch (err) {
					console.log(err)
				};
			}
		},
		mounted: async function () {
			var self = this;

			this.set();

			this.sockets.subscribe("saas_products", (data) => {
				self.set()
			});

		}
	};
</script>
